const through = require('through')

const normalizeHeaders = require('../utils/normalize-headers')

module.exports.encode = jsonEncode
module.exports.decode = jsonDecode

function jsonEncode() {
  return through(function(reqData) {
    // Ensure the properties we need are present.
    reqData.headers = normalizeHeaders(reqData.headers || {})
    reqData.body = reqData.body || ''

    // Fix the Content-type header if body is not a FormData isntance.
    // Undefined Content-type header for form data is necessary for the header to be set properly.
    if (!(reqData.body instanceof FormData)) {
      reqData.headers['content-type'] =
        reqData.headers['content-type'] || 'application/json'
    }
    // Encode the body, if need be.
    if (typeof reqData.body === 'object') {
      if (!(reqData.body instanceof FormData)) {
        reqData.body = JSON.stringify(reqData.body)
      }
    }

    this.queue(reqData)
  })
}

function jsonDecode() {
  return through(function(respData) {
    try {
      if (respData.headers) {
        respData.headers = normalizeHeaders(respData.headers)
        const contentType = respData.headers['content-type']

        if (contentType && contentType.includes('json')) {
          respData.body = JSON.parse(respData.body)
        }
      }

      this.queue(respData)
    } catch (err) {
      this.emit('error', err)
    }
  })
}
